var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag)?_c('div',{staticClass:"be-tag-component"},[_c('span',[_vm._v(_vm._s(_vm.name))]),(_vm.namespace)?_c('span',{staticClass:"be-tag-component__namespace"},[_vm._v(" ("+_vm._s(_vm.namespace)+") ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }